/* TrenBee Reviews - review rail, read-more, progressive loading and multi-photo viewer (test theme). */
(() => {
function tbrRail(root) {
  if (!root || root.dataset.tbrRailReady) return;
  root.dataset.tbrRailReady = '1';
  const $ = (s) => root.querySelector(s);
  const html = document.documentElement;

  /* ---------- read more (only when text is actually clamped) ---------- */
  function checkClamp(scope) {
    scope.querySelectorAll('[data-tbr-text]').forEach((t) => {
      const b = t.parentNode.querySelector('[data-tbr-readmore]');
      if (!b || t.classList.contains('is-open')) return;
      b.hidden = t.scrollHeight <= t.clientHeight + 2;
    });
  }
  root.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-tbr-readmore]');
    if (!rm) return;
    const t = rm.parentNode.querySelector('[data-tbr-text]');
    const open = t.classList.toggle('is-open');
    rm.textContent = open ? 'Read less' : 'Read more';
    rm.setAttribute('aria-expanded', String(open));
  });

  /* ---------- rail ---------- */
  const rail = $('[data-tbr-rail]');
  if (rail) {
    const prev = $('[data-tbr-prev]'), next = $('[data-tbr-next]'), bar = $('[data-tbr-progress]');
    const loadBtn = $('[data-tbr-loadmore]'), tpl = $('[data-tbr-more]');
    let pending = tpl ? [...tpl.content.children] : [];

    const step = () => {
      const c = rail.querySelector('[data-tbr-card]');
      if (!c) return rail.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const w = c.getBoundingClientRect().width + gap;
      return w * Math.max(1, Math.floor((rail.clientWidth + gap) / w));
    };
    function update() {
      const max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2 && !pending.length;
      const vis = Math.min(1, rail.clientWidth / rail.scrollWidth);
      bar.style.width = (vis * 100) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
      root.classList.toggle('tbr-no-scroll', max <= 2 && !pending.length);
    }
    function loadMore() {
      if (!pending.length) return;
      const batch = pending.splice(0, 12);
      const frag = document.createDocumentFragment();
      batch.forEach((n) => frag.appendChild(n));
      rail.insertBefore(frag, loadBtn);
      if (!pending.length) { loadBtn && loadBtn.remove(); }
      else { const l = loadBtn.querySelector('[data-tbr-left]'); if (l) l.textContent = '(' + pending.length + ')'; }
      checkClamp(rail);
      update();
    }
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => {
      if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2) loadMore();
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    if (loadBtn) {
      loadBtn.addEventListener('click', loadMore);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) loadMore(); }), { root: rail, rootMargin: '0px 240px 0px 0px' }).observe(loadBtn);
      }
    }
    let raf = 0;
    rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', () => { checkClamp(rail); update(); });
    checkClamp(rail);
    update();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { checkClamp(rail); update(); });
  }

  /* ---------- multi-photo viewer ---------- */
  const viewer = $('[data-tbr-viewer]');
  if (!viewer) return;
  const track = $('[data-tbr-vtrack]'), count = $('[data-tbr-vcount]'), info = $('[data-tbr-vinfo]');
  const vprev = $('[data-tbr-vprev]'), vnext = $('[data-tbr-vnext]');
  let total = 0, lastFocus = null;

  const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  function paint() {
    const i = current();
    count.textContent = (i + 1) + ' / ' + total;
    vprev.disabled = i <= 0;
    vnext.disabled = i >= total - 1;
  }
  function go(i) {
    i = Math.max(0, Math.min(total - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function open(btn) {
    let photos = [];
    try { photos = JSON.parse(btn.dataset.photos || '[]'); } catch (_) { photos = []; }
    if (!photos.length) return;
    total = photos.length;
    track.textContent = '';
    photos.forEach((p, i) => {
      const slide = document.createElement('div');
      slide.className = 'tbr-viewer__slide';
      const img = document.createElement('img');
      img.src = p.b;
      img.srcset = p.a + ' 720w, ' + p.b + ' 1080w, ' + p.c + ' 1440w';
      img.sizes = '(min-width: 990px) 62vw, 100vw';
      img.width = p.w; img.height = p.h;
      img.alt = 'Customer photo ' + (i + 1) + ' of ' + total;
      img.decoding = 'async';
      img.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
    });
    const body = btn.closest('[data-tbr-card]').querySelector('.tbr-c__body').cloneNode(true);
    body.querySelectorAll('[data-tbr-readmore]').forEach((n) => n.remove());
    body.querySelectorAll('[data-tbr-text]').forEach((n) => { n.classList.add('is-open'); n.removeAttribute('data-tbr-text'); });
    info.textContent = '';
    info.appendChild(body);
    viewer.classList.toggle('is-single', total === 1);
    lastFocus = document.activeElement;
    viewer.hidden = false;
    html.classList.add('tbr-lock');
    track.scrollLeft = 0;
    paint();
    setTimeout(() => { const c = viewer.querySelector('.tbr-viewer__close'); c && c.focus(); }, 30);
  }
  function close() {
    viewer.hidden = true;
    track.textContent = '';
    html.classList.remove('tbr-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.addEventListener('click', (e) => {
    const v = e.target.closest('[data-tbr-view]');
    if (v) { open(v); return; }
    if (e.target.closest('[data-tbr-vclose]')) close();
  });
  vprev.addEventListener('click', () => go(current() - 1));
  vnext.addEventListener('click', () => go(current() + 1));
  let vraf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(vraf); vraf = requestAnimationFrame(paint); }, { passive: true });
  document.addEventListener('keydown', (e) => {
    if (viewer.hidden) return;
    if (e.key === 'Escape') { e.stopPropagation(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    else if (e.key === 'Tab') {
      const f = [...viewer.querySelectorAll('button')].filter((x) => !x.disabled && x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  window.addEventListener('resize', () => { if (!viewer.hidden) paint(); });
}
document.querySelectorAll('[data-tbr-pdp]').forEach(tbrRail);
document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-tbr-pdp]'); if (r) tbrRail(r); });
})();